import { render, staticRenderFns } from "./PhotoSelector.vue?vue&type=template&id=584cb9b8&scoped=true&"
import script from "./PhotoSelector.vue?vue&type=script&lang=js&"
export * from "./PhotoSelector.vue?vue&type=script&lang=js&"
import style0 from "./PhotoSelector.vue?vue&type=style&index=0&id=584cb9b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584cb9b8",
  null
  
)

export default component.exports